import {
  FileData,
  UseLoadFile,
} from '@wandb/weave/common/components/FileBrowser';
import React from 'react';

import {useSingleFileQuery} from '../../../generated/graphql';
import {useLoadFile} from '../../../util/requests';
import {DEFAULT_LAUNCH_PROJECT_NAME} from '../constants';
import {LogPreview} from './LogPreview';

export type RunQueueItemModalLogViewerProps = {
  filePath: string;
  runName: string;
  entityName: string;
};

export const RunQueueItemModalLogViewer: React.FC<
  RunQueueItemModalLogViewerProps
> = ({entityName, runName, filePath}) => {
  const singleFileQuery = useSingleFileQuery({
    variables: {
      entityName,
      projectName: DEFAULT_LAUNCH_PROJECT_NAME,
      runName,
      fileName: filePath,
    },
  });

  const useLoadRunFile: UseLoadFile = (file, options) => {
    return useLoadFile(
      {entityName, projectName: DEFAULT_LAUNCH_PROJECT_NAME, runName},
      file.name,
      options
    );
  };
  if (singleFileQuery.loading || singleFileQuery.error) {
    return null;
  }

  return (
    <LogPreview
      useLoadFile={useLoadRunFile}
      file={
        singleFileQuery.data?.project?.run?.files?.edges[0].node as FileData
      }
      language="python"
    />
  );
};
